export default {
  namespaced: true,
  state: {
    pageName: '',
    params: null,
  },
  mutations: {
    set(state, payload) {
      state.pageName = payload.pageName;
      state.params = payload.params;
    },
    reset(state) {
      state.pageName = '';
      state.params = null;
    },
  },
  actions: {
    set({ commit }, payload) {
      commit('set', payload);
    },
    reset({ commit }) {
      commit('reset');
    },
  },
  getters: {
    getPageData: (state) => ({
      pageName: state.pageName,
      params: state.params,
    }),
  },
};
